import { useState, useEffect } from 'react';
import { AbstractForm, AbstractFormState, IStateForm } from '../../../common/AbstractForm';
import FormModel from '../../../../utils/FormModel';
import OnPremSiteToSiteVPNConfiguration from '../../../../models/entities/OnPremSiteToSiteVPNConfiguration';

export interface ISiteToSiteVPNConfigurationFormStateForm extends IStateForm {
	inboundEndpointType: string;
	endpointLocation: string;
	endpointIP: string;
	authenticationIP: string;
	vpnMode: string;
	negotiationMode: string;
	replyDetection: string;
}

export interface AbstractSiteToSiteVPNConfigurationForm<T> extends AbstractFormState<T> {
}

export const useAbstractSiteToSiteVPNConfigurationForm = (props) => {
	const [state, setState] = useState<AbstractSiteToSiteVPNConfigurationForm<ISiteToSiteVPNConfigurationFormStateForm>>({
		stateForm: {
			inboundEndpointType: props.source == 'exxon' ? 'Fortigate' : null,
			endpointLocation: null,
			endpointIP: null,
			authenticationIP: null,
			vpnMode: 'Tunnel',
			negotiationMode: 'Main',
			replyDetection: 'Enabled',
		},
	});


	useEffect(() => {
		if (props.mode === 'detail' || props.mode === 'edit') {
			const config = props.source === 'exxon' ? props.exxonConfig : props.externalConfig;
			if (config) {
				setState(prevState => {
					const newState = {
						...prevState,
						stateForm: { ...config }
					};
					props.onChange(new OnPremSiteToSiteVPNConfiguration(newState.stateForm));
					return newState;
				});
			}
		}
	}, []);


	const abstractFormInstance = new (class extends AbstractForm<{}, AbstractSiteToSiteVPNConfigurationForm<ISiteToSiteVPNConfigurationFormStateForm>> {
		constructor() {
			super({});
			this.state = state;
		}
	})();

	const [formModel] = useState<FormModel>(
		abstractFormInstance.formModel = new FormModel({
			inboundEndpointType: {
				getValue: () => state.stateForm.inboundEndpointType,
				validation: {
					required: true,
				},
			},
			endpointLocation: {
				getValue: () => state.stateForm.endpointLocation,
				validation: {
					required: true,
				},
			},
			endpointIP: {
				getValue: () => state.stateForm.endpointIP,
				validation: {
					required: true,
				},
			},
			authenticationIP: {
				getValue: () => state.stateForm.authenticationIP,
				validation: {
					required: true,
				},
			},
			vpnMode: {
				getValue: () => state.stateForm.vpnMode,
				validation: {
					required: true,
				},
			},
			negotiationMode: {
				getValue: () => state.stateForm.negotiationMode,
				validation: {
					required: true,
				},
			},
			replyDetection: {
				getValue: () => state.stateForm.replyDetection,
				validation: {
					required: true,
				},
			},
		}));

	const handleStateFormChange = (field: string, value: any) => {
		abstractFormInstance.setState = (newState) => setState((prevState) => ({ ...prevState, ...newState }));
		abstractFormInstance.handleStateFormChange(field, value);
	};

	const endpointLocationToIP = {
		'Amsterdan COLO': '158.26.144.33',
		'Singapore COLO': '158.26.208.33',
		'Houston Campus': '158.26.5.34',
		'AWS London': '158.26.168.8',
		'AWS Singapore': '158.26.216.8',
		'Ohio': '158.26.56.20',
	};

	const getStateFormHandlers = () => {
		return {
			inboundEndpointType: {
				value: state.stateForm.inboundEndpointType,
				validation: formModel.fields.inboundEndpointType?.validation,
				onChange: (event) => {
					handleStateFormChange('inboundEndpointType', event.target.value);
				},
			},
			endpointLocation: {
				value: state.stateForm.endpointLocation,
				validation: formModel.fields.endpointLocation?.validation,
				options: props.source == 'exxon'  ? [
					{ text: 'Amsterdan COLO', value: 'Amsterdan COLO' },
					{ text: 'Singapore COLO', value: 'Singapore COLO' },
					{ text: 'Houston Campus', value: 'Houston Campus' },
					{ text: 'AWS London', value: 'AWS London' },
					{ text: 'AWS Singapore', value: 'AWS Singapore' },
					{ text: 'Ohio', value: 'Ohio' },
				] : [],
				onChange: (event) => {
					handleStateFormChange('endpointLocation', event.target.value);
                	handleStateFormChange('endpointIP', endpointLocationToIP[event.target.value]);
				},
			},
			endpointIP: {
				value: state.stateForm.endpointIP,
				validation: formModel.fields.endpointIP?.validation,
				onChange: (event) => {
					handleStateFormChange('endpointIP', event.target.value);
				},
			},
			vpnMode: {
				value: state.stateForm.vpnMode,
				validation: formModel.fields.vpnMode?.validation,
				onChange: (event) => {
					handleStateFormChange('vpnMode', event.target.value);
				},
			},
			negotiationMode: {
				value: state.stateForm.negotiationMode,
				validation: formModel.fields.negotiationMode?.validation,
				onChange: (event) => {
					handleStateFormChange('negotiationMode', event.target.value);
				},
			},
			replyDetection: {
				value: state.stateForm.replyDetection,
				validation: formModel.fields.replyDetection?.validation,
				onChange: (event) => {
					handleStateFormChange('replyDetection', event.target.value);
				},
			},
		};
	};

	const isValid = () => {
		console.log(formModel);
		console.log(!formModel)
		return true;
		return !formModel && formModel.isValid();
	};

	return {
		state,
		formModel,
		setState,
		handleStateFormChange,
		getStateFormHandlers,
		isValid,
	};
};